import $ from 'jquery';
import 'jquery-ui/ui/widgets/tabs';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/i18n/datepicker-fr-CA';
import { Calendar } from 'fullcalendar';
import {initSelects} from "./selects";

$(document).ready(function () {
    const $eventsTabs = $('.eventsTabs');
    const breakpoint = 1120;
    let selectedDate = '';//formatDate(new Date());

    function toggleTabs() {
        const shouldEnableTabs = innerWidth >= breakpoint;
        const isInitialized = $eventsTabs.hasClass('ui-tabs');

        if (shouldEnableTabs && !isInitialized) {
            $eventsTabs.tabs({
                activate: function (event, ui) {
                    const panelId = ui.newPanel.attr('id');

                    if (panelId && window.location.hash !== '#' + panelId) {
                        history.pushState(null, '', '#' + panelId);
                    }

                    eventsCalendar.render();
                    eventsDatepicker.render();
                },
            });
        }

        if (!shouldEnableTabs && isInitialized) {
            $eventsTabs.tabs('destroy');
        }
    }


    function activateTabFromHash() {
        const hash = location.hash;

        if (!$eventsTabs.hasClass('ui-tabs')) {
            return;
        }

        if (!hash || innerWidth < breakpoint) {
            return;
        }

        const $targetTabLink = $eventsTabs.find('a[href="' + hash + '"]');

        if ($targetTabLink.length) {
            const index = $targetTabLink.parent().index();

            if ($eventsTabs.tabs('option', 'active') !== index) {
                $eventsTabs.tabs('option', 'active', index);
            }
        }
    }


    $(window).on('load resize', toggleTabs);
    activateTabFromHash();
    $(window).on('hashchange', activateTabFromHash);

    function initCategorySelect() {
        initSelects('.events__sidebar select');
    }
    initCategorySelect();



    let eventsCalendar;
    $('.eventsCalendar').each(function (index, element) {
        eventsCalendar = new Calendar(element, {
            initialView: innerWidth < 640 ? 'listMonth' : 'dayGridMonth',
            locale: $('html').attr('lang'),
            buttonText: {
                'today': $('html').attr('lang') === 'fr-CA' ? 'Aujourd\'hui' : 'Today',
            },
            eventSources: [
                {
                    url: selectrum.ajax_url,
                    method: 'GET',
                    extraParams: {
                        action: 'get_calendar_events'
                    },
                    failure: function () {
                        //alert('Erreur lors du chargement des événements');
                    }
                }
            ],
        });
        eventsCalendar.render();
    });


    $(document).on('click', '.eventsDatepicker__button', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $button = $(this);
        const $eventsDatepicker = $button.closest('.eventsDatepicker');
        $eventsDatepicker.toggleClass('open');
    });
    $(document).on('click', '.eventsDatepicker__dropdown', function (e) {
        e.stopPropagation();
    });
    $(document).on('click', function (e) {
        $('.eventsDatepicker').removeClass('open');
    })


    let eventsDatepicker;
    $('.eventsDatepicker__calendar').each(function (index, element) {
        eventsDatepicker = new Calendar(element, {
            initialView: 'dayGridMonth',
            locale: 'fr',
            //initialDate: '2026-03-12',
            //firstDay: 0,
            height: 'auto',
            fixedWeekCount: false,
            showNonCurrentDates: true,
            headerToolbar: {
                left: 'prev',
                center: 'title',
                right: 'next'
            },
            titleFormat: {
                month: 'long',
                year: 'numeric'
            },
            dayHeaderFormat: { weekday: 'narrow' },
            eventSources: [
                {
                    url: selectrum.ajax_url,
                    method: 'GET',
                    extraParams: {
                        action: 'get_calendar_events'
                    },
                    failure: function () {
                        //alert('Erreur lors du chargement des événements');
                    }
                }
            ],
            selectable: true,
            selectAllow: function (selectInfo) {
                const events = eventsDatepicker.getEvents();

                // currentStart/currentEnd represent the real month range in dayGridMonth
                const monthStart = selectInfo.startStr;
                const monthEnd = selectInfo.endStr;
                const hasEvent = events.some(function (event) {
                    return rangesOverlap(
                        selectInfo.start,
                        selectInfo.end,
                        event.start,
                        event.end || event.start
                    );
                });

                // FullCalendar selection end is exclusive
                return selectInfo.start >= monthStart && selectInfo.end <= monthEnd && hasEvent;
            },
            datesSet: function () {
                setTimeout(function () {
                    highlightEventDays(eventsDatepicker);
                }, 0);
            },
            eventDidMount: function () {
                highlightEventDays(eventsDatepicker);
            },
            dateClick: function(info) {
                const view = info.view;
                const clickedDate = info.dateStr;
                const events = eventsDatepicker.getEvents();
                const hasEvents = events.some(function (event) {
                    return eventOccursOnDate(event, clickedDate);
                });

                if (info.date < view.currentStart || info.date >= view.currentEnd || !hasEvents) {
                    return;
                }

                // Visually update selected day
                document.querySelectorAll('.selected-day').forEach(function(day) {
                    day.classList.remove('selected-day');
                });

                $('.eventsDatepicker').removeClass('open');
                $('.eventsDatepicker__button').text(info.view.title);

                info.dayEl.classList.add('selected-day');
                selectedDate = clickedDate;

                updateEvents(location.href);
            }
        });
        eventsDatepicker.render();
    });


    function eventOccursOnDate(event, dateStr) {
        const dayStart = new Date(dateStr + 'T00:00:00');
        const dayEnd = new Date(dayStart);
        dayEnd.setDate(dayEnd.getDate() + 1);

        const eventStart = event.start;
        const eventEnd = event.end || getDefaultEventEnd(event);

        return eventStart < dayEnd && eventEnd > dayStart;
    }


    function getDefaultEventEnd(event) {
        const end = new Date(event.start);

        if (event.allDay) {
            end.setDate(end.getDate() + 1);
        }

        return end;
    }


    function rangesOverlap(startA, endA, startB, endB) {
        return startA < endB && endA > startB;
    }


    function highlightEventDays(calendar) {
        document.querySelectorAll('.eventsDatepicker .fc-daygrid-day').forEach(function (dayEl) {
            dayEl.classList.remove('has-event');
        });

        calendar.getEvents().forEach(function (event) {
            const start = new Date(event.start);
            const end = event.end ? new Date(event.end) : new Date(event.start);

            let current = new Date(start.getFullYear(), start.getMonth(), start.getDate());
            const last = event.end
                ? new Date(end.getFullYear(), end.getMonth(), end.getDate())
                : new Date(current.getFullYear(), current.getMonth(), current.getDate() + 1);

            while (current < last) {
                const dateString = formatDate(current);
                const dayEl = document.querySelector('.eventsDatepicker .fc-daygrid-day[data-date="' + dateString + '"]');

                if (dayEl) {
                    dayEl.classList.add('has-event');
                }

                current.setDate(current.getDate() + 1);
            }
        });
    }

    function formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return year + '-' + month + '-' + day;
    }

    /*
    $.datepicker.setDefaults($.datepicker.regional[ $('html').attr('lang') ]);
    $('.eventsDatepicker').datepicker({
        showOtherMonths: true,
        prevText: '',
        nextText: '',
        beforeShowDay: function(date) {
            return [true, 'has-event'];
        },
        onSelect: function(dateText, inst) {

        }
    });
    */


    function updateEvents(url) {
        $('.eventsListing').css('opacity', '0.3');
        $.ajax({
            url: url,
            type: 'POST',
            data: {
                date: selectedDate,
                category: $('#category').val(),
                location: $('#location').val(),
            },
            success: function (response) {
                $('.eventsListing').replaceWith($(response).find('.eventsListing'));
                initCategorySelect();
            },
        });
    }


    $(document).on('click', '.eventsListing__pagination a', function (e) {
        e.preventDefault();
        const url = $(this).attr('href');
        updateEvents(url);
        scrollTo({
            top: $('.events__main').offset().top - 30,
            behavior: 'smooth'
        });
    });

    $(document).on('change', '#category', function () {
        updateEvents(location.href);
    });

    $(document).on('submit', '.eventsLocationForm', function (e) {
        e.preventDefault();
        updateEvents(location.href);
    });


    $(document).on('click', '[data-add-to-calendar]', function (e) {
        e.preventDefault();
        const event_id = $(this).data('id');
        const filename = $(this).data('filename');
        $.ajax({
            url: selectrum.ajax_url,
            type: 'POST',
            data: {
                action: 'get_event_ics',
                event_id: event_id,
            },
            xhrFields: {
                responseType: 'blob',
            },
            success: function (response) {
                const downloadUrl = URL.createObjectURL(response);
                const link = document.createElement('a');

                link.href = downloadUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();

                URL.revokeObjectURL(downloadUrl);
            }
        });
    })
});